import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { useLanguage } from "../../contexts/LanguageContext";

export const LEGAL_NAV = [
  { to: "/privacy", key: "legal.privacy" },
  { to: "/cookies", key: "legal.cookies" },
  { to: "/terms", key: "legal.terms" },
];

const LegalLinks = ({ exclude }) => {
  const { t } = useLanguage();
  const items = LEGAL_NAV.filter((item) => item.to !== exclude);

  return (
    <Nav aria-label={t("legal.aria")}>
      {items.map((item) => (
        <NavLink key={item.to} to={item.to}>
          {t(item.key)}
        </NavLink>
      ))}
    </Nav>
  );
};

export default LegalLinks;

const Nav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 10px 16px;
  color: var(--ink-soft);

  a {
    text-decoration: none;
    color: inherit;
    font-size: 13px;
    font-weight: 500;
  }

  a:hover,
  a.active {
    color: var(--ink);
  }
`;
